<script lang="ts">
	import type ApexCharts from 'apexcharts';
	import type { ApexOptions } from 'apexcharts';
	import { Button } from '$global/components/Button';
	import { Chart } from '$global/components/Chart';
	import { createDialogStores } from '$global/components/Dialog';
	import { Dialog } from '$global/components/Dialog';

	interface Props {
		buttonLabel?: string;
		buttonData?: {
			title?: string;
			apex: ApexOptions;
			yaxisNumberFormat: Intl.NumberFormatOptions;
		};
	}

	let { buttonLabel = 'View Chart', buttonData }: Props = $props();

	const dataCy = 'modal-graph-button';

	let chart: ApexCharts | undefined = $state();
	let dialogStores = createDialogStores();

	let title = $derived(buttonData?.title || '');

	let chartOptions = $derived({
		...buttonData?.apex,
		yaxis: {
			...buttonData?.apex?.yaxis,
			labels: {
				...(buttonData?.apex?.yaxis as { labels: object })?.labels,
				formatter: (value: number) => {
					if (!yaxisNumberFormat) return `${value}`;

					return new Intl.NumberFormat('en-US', yaxisNumberFormat).format(
						value
					);
				},
			},
		},
	});

	let yaxisNumberFormat = $derived(buttonData?.yaxisNumberFormat || undefined);

	const handleClick = () => {
		dialogStores.states.open.set(true);
	};
</script>

<div>
	<Button {dataCy} size="sm" variant="primary" onclick={handleClick}>
		{buttonLabel}
	</Button>

	<Dialog
		{title}
		{dialogStores}
		{dataCy}
		class="max-h-[90vh] w-[98vw] max-w-[1200px] px-2 lg:w-[85vw]"
		classes={{
			title: 'text-xl font-semibold mb-4',
		}}
	>
		<div class="min-h-[300px] w-full sm:min-h-[450px] lg:min-h-[550px]">
			<Chart
				bind:chart
				id={`chart-${dataCy}`}
				options={chartOptions}
				{dataCy}
				class="h-full w-full"
			/>
		</div>
	</Dialog>
</div>
